import { IScheduledDeliveryRepository } from '../../ports/IScheduledDeliveryRepository'
import { ScheduledDeliveryEntity } from '../../../domain/entities/ScheduledDelivery'

export class GetScheduledDeliveryUseCase {
  constructor(private repo: IScheduledDeliveryRepository) {}
  async execute(uuid: string): Promise<ScheduledDeliveryEntity | null> {
    return this.repo.get(uuid)
  }
}
